<itl-wizard-page
  [isSinglePage]="true"
  [showOnlyCancel]="true"
  [pageTitleTransPath]="'kim.recipientSearch.title'"
  (cancelClicked)="cancel()"
>
  <itl-search-filter-bar
    [placeholder]="'kim.recipientSearch.searchPlaceholder' | translate"
    [(value)]="searchTerm"
    [filterActive]="filterActive"
    [disabled]="searching"
    (searchValueChanged)="search()"
    (filterTypePressed)="openFilter()"
    (resetFilter)="resetFilter()"
  ></itl-search-filter-bar>

  <itl-loading-indicator *ngIf="searching" [delay]="0"></itl-loading-indicator>

  <div class="recipient-list" *ngIf="!searching && recipients.length">
    <button
      class="recipient-list__item"
      *ngFor="let recipient of recipients"
      (click)="select(recipient)"
      data-testid="kim-recipient-item"
    >
      <div class="recipient-list__name">{{ recipient.displayName }}</div>
      <div class="recipient-list__detail" *ngIf="recipient.telematikId">{{ recipient.telematikId }}</div>
      <div class="recipient-list__detail" *ngIf="formatAddress(recipient)">{{ formatAddress(recipient) }}</div>
      <div class="recipient-list__kim-address">{{ recipient.kimAddress }}</div>
    </button>
  </div>

  <itl-warning-item *ngIf="!searching && hasSearched && !recipients.length">
    {{ 'kim.recipientSearch.emptyState' | translate }}
  </itl-warning-item>
</itl-wizard-page>
